import { leadMessage, initialLeadMessage } from '@/api/backoffice';

export const mutationTypes = {
  setInitialMessage: '[leadMessages] set initial message',
  setLeadMessage: '[leadMessages] set lead message',
  clearMessages: '[leadMessages] clear messages',
};

export default {
  namespaced: true,
  state: () => ({
    initialMessage: null,
    leadMessage: null,
  }),
  mutations: {
    [mutationTypes.setInitialMessage](state, payload) {
      state.initialMessage = payload;
    },
    [mutationTypes.setLeadMessage](state, payload) {
      state.leadMessage = payload;
    },
    [mutationTypes.clearMessages](state) {
      state.initialMessage = null;
      state.leadMessage = null;
    },
  },
  actions: {
    async fetchInitial({ commit }, { guid, shouldFetch }) {
      if (!shouldFetch) return;
      const res = await initialLeadMessage(guid, shouldFetch);
      commit(mutationTypes.setInitialMessage, res?.data?.data || null);
    },
    async fetchLead({ commit }, { guid, lead }) {
      const res = await leadMessage(guid, lead);
      commit(mutationTypes.setLeadMessage, res?.data?.data || null);
    },
    clearMessages({ commit }) {
      commit(mutationTypes.clearMessages);
    },
  },
};
